export class AlbumModel {
  id: number;
  name: string;
  artist: string;
  uri: string;
  imageUrl: string;
}
